import { render } from "./LocationContent.vue?vue&type=template&id=538c0484&scoped=true"
import script from "./LocationContent.vue?vue&type=script&lang=js"
export * from "./LocationContent.vue?vue&type=script&lang=js"

import "./LocationContent.vue?vue&type=style&index=0&id=538c0484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538c0484"]])

export default __exports__